import { isMobileOnly } from 'react-device-detect';
import { IStyles } from '@interfaces/styles';
import { colors } from '@constants/colors';

export const useStyles = (): IStyles => {
  return {
    root: {
      '& .MuiDivider-root': {
        my: isMobileOnly ? 0.5 : 1.5,
        backgroundColor: '#FFFFFF4D',
      },
    },
    menu: {
      color: colors.white,
      padding: 0,
      gap: 0.5,
    },
    link: {
      paddingX: 0,
      paddingY: 0.5,

      '& .MuiListItemIcon-root': {
        minWidth: 28,
      },
    },
    linkText: {
      minWidth: 0,

      '& .MuiListItemText-primary': {
        fontSize: 14,
        lineHeight: 1.5,
        letterSpacing: '0.02em',
        display: 'block',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
      },
    },
    menuOptionMobile: {
      display: 'flex',
      justifyContent: 'space-between',
    },
  };
};
